"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterDateDuration = exports.DateDuration = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@apitable/components");
const core_1 = require("@apitable/core");
const DurationStringsMap = {
    [core_1.FilterDuration.ExactDate]: (0, core_1.t)(core_1.Strings.exact_date),
    [core_1.FilterDuration.DateRange]: (0, core_1.t)(core_1.Strings.date_range),
    [core_1.FilterDuration.Today]: (0, core_1.t)(core_1.Strings.today),
    [core_1.FilterDuration.Tomorrow]: (0, core_1.t)(core_1.Strings.tomorrow),
    [core_1.FilterDuration.Yesterday]: (0, core_1.t)(core_1.Strings.yesterday),
    [core_1.FilterDuration.ThisWeek]: (0, core_1.t)(core_1.Strings.this_week),
    [core_1.FilterDuration.PreviousWeek]: (0, core_1.t)(core_1.Strings.previous_week),
    [core_1.FilterDuration.ThisMonth]: (0, core_1.t)(core_1.Strings.this_month),
    [core_1.FilterDuration.PreviousMonth]: (0, core_1.t)(core_1.Strings.previous_month),
    [core_1.FilterDuration.ThisYear]: (0, core_1.t)(core_1.Strings.this_year),
    [core_1.FilterDuration.SomeDayBefore]: (0, core_1.t)(core_1.Strings.some_day_before),
    [core_1.FilterDuration.SomeDayAfter]: (0, core_1.t)(core_1.Strings.some_day_after),
    [core_1.FilterDuration.TheLastWeek]: (0, core_1.t)(core_1.Strings.the_last_week),
    [core_1.FilterDuration.TheNextWeek]: (0, core_1.t)(core_1.Strings.the_next_week),
    [core_1.FilterDuration.TheLastMonth]: (0, core_1.t)(core_1.Strings.the_last_month),
    [core_1.FilterDuration.TheNextMonth]: (0, core_1.t)(core_1.Strings.the_next_month),
};
exports.DateDuration = [
    core_1.FilterDuration.ExactDate,
    core_1.FilterDuration.Today,
    core_1.FilterDuration.Yesterday,
    core_1.FilterDuration.Tomorrow,
    core_1.FilterDuration.SomeDayBefore,
    core_1.FilterDuration.SomeDayAfter,
];
const FilterDateDuration = props => {
    const { value, onChange, operator } = props;
    function createOptionData() {
        let filterDuration = Object.values(core_1.FilterDuration).filter(item => {
            return item !== core_1.FilterDuration.SomeDayAfter && item !== core_1.FilterDuration.SomeDayBefore;
        });
        if (operator === core_1.FOperator.IsLess ||
            operator === core_1.FOperator.IsLessEqual ||
            operator === core_1.FOperator.IsGreater ||
            operator === core_1.FOperator.IsGreaterEqual) {
            filterDuration = exports.DateDuration;
        }
        return filterDuration.map(item => {
            return {
                label: DurationStringsMap[item],
                value: item,
            };
        });
    }
    return (react_1.default.createElement(components_1.Select, { placeholder: (0, core_1.t)(core_1.Strings.pick_one_option), value: value, options: createOptionData(), onSelected: (option) => onChange(option.value), dropdownMatchSelectWidth: false, openSearch: false, triggerStyle: { width: 100 } }));
};
exports.FilterDateDuration = FilterDateDuration;
